import React from "react";
import "./Styles.css";
import { Box, Container, Grid, Skeleton, Stack } from "@mui/material";

export function DesktopView() {
    return <Container className="desktopView">
        <Grid container spacing={4}>
            <Grid item md={8} sm={12}>
                <Skeleton height={443} variant="rectangular" className="imageSkeleton" />
                <Box sx={{ marginTop: '20px' }} >
                    <Skeleton height={50} width={300} sx={{ mb: 2 }} />
                    <Stack direction={'row'} spacing={1} alignItems="center" sx={{ mb: 2 }}>
                        <Skeleton variant="circular" width={40} height={40} />
                        <Skeleton width={200} height={30} />
                    </Stack>
                    {
                        [...Array(5)].map(() => {
                            return <Skeleton sx={{ mb: 1 }} />
                        })
                    }
                </Box>
            </Grid>
            <Grid item md={4} sm={12} >
                <Box className="donationCard">
                    <Skeleton height={50} width={250} />
                    <Skeleton height={10} />
                    <Skeleton height={15} sx={{ mt: 1, mb: 1 }} />
                    <Skeleton height={10} />
                    <Skeleton height={40} variant="rectangular" className="cardButtons" sx={{ mt: 4 }} />
                    <Skeleton height={40} variant="rectangular" className="cardButtons" />
                    <Box sx={{mt: 3}}>
                        {[...Array(5)].map(() => {
                            return <Stack direction={'row'} spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                <Skeleton variant="circular" width={40} height={40} />
                                <Box>
                                    <Skeleton height={10} width={200} />
                                    <Skeleton height={20} width={200} />
                                </Box>
                            </Stack>
                        })}
                    </Box>
                    <Skeleton height={40} variant="rectangular" className="cardButtons" sx={{mt: 3}} />
                </Box>
            </Grid>
        </Grid>
    </Container>
}